module.exports = __webpack_public_path__ + "assets/7b88fd1114ce12670208a99a6fa80e4e.png";